import { useEffect, useState } from 'react';
import { Toolbar, Typography, Grid, IconButton, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const instagramUrl = 'https://instagram.com/bandicootimaging?igshid=YmMyMTA2M2Y=';
const linkedInUrl = 'https://www.linkedin.com/company/bandicoot-imaging-sciences';
const youTubeUrl = 'https://www.youtube.com/channel/UCIQjGjAlo5GY6C34Cx0v_GQ/featured';
const contactUrl = 'https://www.bandicootimaging.com/contact/contact';
const termsUrl = 'https://samples.bandicootimaging.com.au/legal/bandicoot-website-terms-2020-10-28.pdf';
const privacyUrl = 'https://samples.bandicootimaging.com.au/legal/Bandicoot_Imaging_Sciences_Privacy_Statement.pdf';

const useStyles = makeStyles((theme) => ({
  footer: {
    color: '#5d5E60',
    background: '#eaebf0',
    // Keep total footer height in sync with the MaterialViewer.js useEffect that calls setCssWidth()
    marginTop: '4em',
    height: '8em',
    left: 0,
    width: '100%',
  },
  navLink: {
    lineHeight: '40px',
    color: '#5d5E60',
    textDecoration: 'none',
    '&:hover': {
      color: '#003fff',
    },
  },
  menuText: {
    cursor: 'pointer',
    color: '#ffffff',
    marginRight: theme.spacing(2.5),
    marginTop: theme.spacing(-0.5),
    marginBottom: theme.spacing(-0.5),
    '&:hover': {
      color: '#ffffff',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.1em',
    },
  },
  captionText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7em',
    },
  },
  grow: {
    flexGrow: 1,
  },
  sectionFlex: {
    display: 'flex',
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

export default function Footer() {
  const [classes, setClasses] = useState(useStyles());
  const styles = useStyles();

  useEffect(() => {
    async function onLoad() {
      setClasses(styles);
    }

    onLoad();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const footerLinks = (<>
    <Grid container>
      <Grid item>
        <Typography className={classes.menuText}>
          <a href={contactUrl} className={classes.navLink} target='_blank'>Contact us</a>
        </Typography>
      </Grid>
      <Grid item>
        <Typography className={classes.menuText}>
          <a href={termsUrl} className={classes.navLink} target='_blank'>Terms of use</a>
        </Typography>
      </Grid>
      <Grid item>
        <Typography className={classes.menuText}>
          <a href={privacyUrl} className={classes.navLink} target='_blank'>Privacy policy</a>
        </Typography>
      </Grid>
    </Grid>
    <Grid container>
      <Grid item>
        <Typography className={classes.captionText} variant='caption'>
          © Bandicoot Imaging Sciences {new Date().getFullYear()}. All Rights Reserved.
        </Typography>
      </Grid>
    </Grid>
  </>);

  const footerIcons = (
    <Grid container alignItems='center' justifyContent='center' style={{marginTop: '10px'}}>
      <Tooltip title='Email us'>
        <IconButton size='small' onClick={() => openInNewTab(contactUrl)}>
          <img src='emailIcon.png' style={{width: '32px', height: '32px'}} />
        </IconButton>
      </Tooltip>
      <Tooltip title='LinkedIn'>
        <IconButton size='small' onClick={() => openInNewTab(linkedInUrl)}>
          <img src='linkedInIcon.png' style={{width: '32px', height: '32px'}} />
        </IconButton>
      </Tooltip>
      <Tooltip title='Instagram'>
        <IconButton size='small' onClick={() => openInNewTab(instagramUrl)}>
          <img src='instagramIcon.png' style={{width: '32px', height: '32px'}} />
        </IconButton>
      </Tooltip>
      <Tooltip title='YouTube'>
        <IconButton size='small' onClick={() => openInNewTab(youTubeUrl)}>
          <img src='youTubeIcon.png' style={{width: '32px', height: '32px'}} />
        </IconButton>
      </Tooltip>
    </Grid>
  );

  async function openInNewTab(url) {
    window.open(url, '_blank');
  }

  return (
    <Toolbar className={classes.footer}>
      <Grid container className={classes.sectionDesktop}>
        <Grid item xs={5}>{footerLinks}</Grid>
        <Grid item xs={2}>{footerIcons}</Grid>
        <Grid item xs={5}></Grid>
      </Grid>
      <Grid container className={classes.sectionMobile}>
        <Grid item className={classes.grow}>{footerLinks}</Grid>
        <Grid item>{footerIcons}</Grid>
      </Grid>
    </Toolbar>
  );
}
